import ImagePath from '../../constants/ImagePath'

const ActionButtons = ({
  onSupportClick,
  onNotificationClick,
  onWalletClick,
  notificationCount
}) => {
  return (
    <div className='flex items-center gap-1 text-sm font-normal text-gray-700 '>
      {/* Support/Enquiry Icon */}
      <div
        onClick={onSupportClick}
        className='w-8 h-8 flex items-center justify-center rounded hover:bg-gray-200 cursor-pointer'
      >
        <img
          src={ImagePath.enquiryicon}
          className='w-5 h-5'
          alt='enquiry icon'
        />
      </div>

      {/* Divider */}
      <span className='filter_space'>
        &nbsp;
        <img src={ImagePath.middleline} className='h-5' alt='line' />
        &nbsp;
      </span>

      {/* Notification Icon */}
      <div
        onClick={onNotificationClick}
        className='w-8 h-8 flex items-center justify-center rounded hover:bg-gray-200 cursor-pointer'
      >
        <img
          src={
            notificationCount === 0 ? ImagePath.bellicon1 : ImagePath.bellicon
          }
          className='w-5 h-5'
          alt='notification icon'
        />
      </div>

      {/* Divider */}
      <span className='filter_space'>
        &nbsp;
        <img src={ImagePath.middleline} className='h-5' alt='line' />
        &nbsp;
      </span>

      {/* Wallet Icon */}
      <div
        onClick={onWalletClick}
        className='w-8 h-8 flex items-center justify-center rounded hover:bg-gray-200 cursor-pointer'
      >
        <img src={ImagePath.wallet} className='w-5 h-5' alt='wallet icon' />
      </div>
    </div>
  )
}

export default ActionButtons
